skrilla.directive('etherscanTransaction', function () {
  return {
    templateUrl: 'directives/etherscanTransaction/etherscanTransaction.html',
    scope: {
      hash: "=",
      text: "="
    },
    controller: function ($scope, envService) {

      $scope.getUri = function () {
        return envService.read('etherscanUrl');
      }

    }
  };
});